<template>
  <v-col cols="12">
    <v-menu
      ref="menu"
      v-model="menuOpen"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :label="label"
          v-model="shortDate"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="props"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="enteredDate"
        @update:modelValue="onDatePicked"
      ></v-date-picker>
    </v-menu>
  </v-col>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useDate } from 'vuetify';

const props = defineProps(['passeddate']);
const enteredDate = ref(props.passeddate.enteredDate);
const label = ref(props.passeddate.label);
const emit = defineEmits(['dateentered']);
const date = useDate();
const menuOpen = ref(false);
let shortDate = date.format(ref(props.modelValue), 'fullDate');

watch(() => enteredDate.value, (newValue) => {
  if (newValue) {
    shortDate = date.format(newValue, 'fullDate');
    // console.log ('date endtered', newValue)
    emit('dateentered', newValue);
  }
});

// Only close menu if a day (numeric) is picked, not when navigating months/years
function onDatePicked(val) {
  enteredDate.value = val;
  // If val is a Date and the day is set, close menu
  if (val && typeof val.getDate === 'function') {
    menuOpen.value = false;
  }
}
</script>